<template>
  <div ref="widgetWrapperEl" class="OB-VUE-WRAPPER" style="width: inherit; height: inherit">
    <div
      class="OUTBRAIN"
      :class="{ 'carousel-ad': props.widgetId === 'AR_21' }"
      v-bind="attrs"
      @click="adClicked()"
    />
  </div>
</template>
<script setup>
  import { getTypeTag } from '~~/assets/js/utils'
  import { isDevelopment } from '~~/assets/js/common'
  import { getNtpUrl } from '~~/assets/js/newtabpage'
  import { sendMixpanelEvent } from '~/utils/host-browser-apis'
  import { getSource } from '~/utils/host-browser-apis/analytics/helper'

  useHead({
    script: [
      {
        type: 'text/javascript',
        src: 'https://widgets.outbrain.com/outbrain.js',
        async: true,
      },
    ],
  })

  const props = defineProps({
    gridPosition: {
      type: Number,
      default: 0,
    },
    widgetId: {
      type: String,
      default: 'AR_5',
    },
    isSummaryPageAd: {
      type: Boolean,
      default: false,
    },
  })

  const removeNullOrEmpty = (obj) => {
    const o = {}
    Object.keys(obj).forEach((key) => obj[key] !== null && obj[key] !== '' && (o[key] = obj[key]))
    return o
  }

  const { locale } = useI18n()
  const baseNtpUrl = getNtpUrl()

  const obPortalUrl = props.isSummaryPageAd ? location.href : baseNtpUrl
  const obLanguage = locale.value
  const externalId = getTypeTag()
  const obInstallationKey = 'ONELA2JBJF199O5BKEIEEDG98'
  const obTest = isDevelopment ? 'test' : null
  const widgetWrapperEl = ref(null)

  const attrs = ref(
    removeNullOrEmpty({
      'data-ob-portalUrl': obPortalUrl,
      'data-ob-language': obLanguage,
      'data-widget-id': props.widgetId,
      'data-external-id': externalId,
      'data-ob-installation-key': obInstallationKey,
      'data-ob-test': obTest,
    })
  )

  const isContainerMarked = () => {
    const el = widgetWrapperEl.value
    const widgetContainer = el.querySelector('.OUTBRAIN')
    if (widgetContainer) {
      return !!widgetContainer.getAttribute('data-ob-mark')
    }
    return false
  }

  const callRenderResearchWidgets = () => {
    const { OBR } = window
    if (OBR && OBR.extern && typeof OBR.extern.researchWidget === 'function') {
      OBR.extern.researchWidget()
    }
  }

  onMounted(async () => {
    if (!isContainerMarked()) {
      callRenderResearchWidgets()
    }
    await sendMixpanelEvent('NtpAd_Rendered', await getEventData())
  })

  const getEventData = async () => {
    const eventData = {
      ntp_tile_position: props.gridPosition,
      ntp_ad_provider: 'outbrain',
      ntp_ad_brand: props.isSummaryPageAd ? 'outbrain' : await getSource('Outbrain', props.widgetId),
      ntp_creative_id: props.widgetId,
    }
    return eventData
  }

  const adClicked = async () => {
    await sendMixpanelEvent('NtpAd_Clicked', await getEventData())
  }
</script>
